import { createAsyncThunk } from '@reduxjs/toolkit';
import { LinkingToolAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { SLICE_NAME } from './models';
import {
  IGetInterLinksResponse,
  ICreateInterLinkResponse,
  IUpdateInterLinkResponse,
  IDeleteInterLinkResponse,
  IGetInterLinksDTO,
  ICreateInterLinkDTO,
  IUpdateInterLinkDTO,
  IDeleteInterLinkDTO,
  IInterLinkImportDTO,
  IInterLinksImportResponse,
  IExportInterLinks,
} from '@/models/linkingTool.model';

export const getLinkingTools = createAsyncThunk<
  IGetInterLinksResponse,
  IGetInterLinksDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getLinkingTools`,
  async (params) => {
    const response = await LinkingToolAPI.getLinkingTools(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const exportInterLinks = createAsyncThunk<Blob, IExportInterLinks, { serializedErrorType: IApiError }>(
  `${SLICE_NAME}/exportInterLinks`,
  async (params) => {
    const response = await LinkingToolAPI.exportInterLinks(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createInterLink = createAsyncThunk<
  ICreateInterLinkResponse,
  ICreateInterLinkDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/createInterLink`,
  async (data) => {
    const response = await LinkingToolAPI.createInterLink(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateInterLink = createAsyncThunk<
  IUpdateInterLinkResponse,
  IUpdateInterLinkDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/updateInterLink`,
  async (data) => {
    const response = await LinkingToolAPI.updateInterLink(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteInterLink = createAsyncThunk<
  IDeleteInterLinkResponse,
  IDeleteInterLinkDTO,
  { serializedErrorType: IApiError; fulfilledMeta: { id: string } }
>(
  `${SLICE_NAME}/deleteInterLink`,
  async (data, thunkAPI) => {
    const response = await LinkingToolAPI.deleteInterLink(data);
    return thunkAPI.fulfillWithValue(response.data, { id: data.id });
  },
  { serializeError: formatApiError },
);

export const importInterLink = createAsyncThunk<
  IInterLinksImportResponse,
  IInterLinkImportDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/importInterLink`,
  async (data) => {
    const response = await LinkingToolAPI.importInterLink(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
